import { Box, Chip, Stack, Typography } from "@mui/material";
import type { SoilPhysicsResultDTO } from "@flaha/shared-types";

import { GlassSurface } from "../../../layouts/components/GlassSurface";
import { PROVENANCE_CHIP } from "../utils/provenanceLabels";
import { PhysicsResultCard } from "./PhysicsResultCard";

interface PhysicsResultsCardProps {
	result: SoilPhysicsResultDTO | null | undefined;
}

export function PhysicsResultsCard({ result }: PhysicsResultsCardProps) {
	return (
		<GlassSurface component="section" aria-labelledby="physics-results-title" sx={{ height: "100%", p: 1 }}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 1.5, pt: 1 }}>
				<Typography id="physics-results-title" component="h2" variant="overline" color="text.secondary">
					Physics evidence
				</Typography>
				<Chip label={PROVENANCE_CHIP.calculated} size="small" variant="outlined" />
			</Stack>
			<Box sx={{ "& > .MuiCard-root": { bgcolor: "transparent", border: 0, boxShadow: "none" } }}>
				<PhysicsResultCard result={result} />
			</Box>
		</GlassSurface>
	);
}
